import { render } from "./EmbarkFlightGroup.vue?vue&type=template&id=c99b5080"
import script from "./EmbarkFlightGroup.vue?vue&type=script&lang=js"
export * from "./EmbarkFlightGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__